import { Check, DeleteForever, Edit } from "@mui/icons-material";
import ConfirmationDialog from "../../../shared/ConfirmationDialog";
import { useState } from "react";
import { Button } from "@mui/material";

const VariantImageCard = ({
  item,
  setState,
  selectedImage,
  setSelectedImage,
  imageData,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleSelect = (id) => {
    setSelectedImage((prev) => {
      const isPresent = prev.includes(id);

      if (isPresent) {
        return prev.filter((i) => i !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  const isSelected = selectedImage.includes(item.id);
  return (
    <div
      className={`card rounded-lg shadow-xl !bg-base-100  cursor-pointer relative h-60 !mb-4 ${
        isSelected && "!border-green-500 !border-4  !rounded-lg"
      }`}
      onClick={() => handleSelect(item.id)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        alt=""
        src={item?.variant_image}
        className="h-full !rounded-md !w-full"
      />
      {isSelected && (
        <img
          src="https://www.iconpacks.net/icons/5/free-greem-check-mark-approval-icon-16196-thumb.png"
          alt=""
          className="absolute h-7 w-7  right-1 top-1"
        />
      )}

      {isHovered && !isSelected && (
        <div className="absolute  left-0 w-full top-0 h-full border-4 border-green-500 flex-row py-1 bg-gray-300 bg-opacity-20 !rounded-md card-body flex justify-center card-actions"></div>
      )}
    </div>
  );
};

export default VariantImageCard;
